import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ModalService } from 'src/app/shared/services/modal.service';
import { CustomValidator } from 'src/app/shared/validators/custom-validator';
import { IFuncionario } from 'src/app/shared/interfaces/funcionario/ifuncionario';
import { funcionarioActions } from 'src/app/store/funcionario/funcionario.actions';
import { Store } from '@ngrx/store';
import { IFuncionarioState } from 'src/app/store/funcionario/funcionario.reducer';
import { PostalCodeService } from 'src/app/shared/services/postal-code.service';
import { loadUnidade } from 'src/app/store/unidade/unidade.actions';
import { selectUnidadeLista, selectUnitActiveList, selectUnitState } from 'src/app/store/unidade/unidade.selectors';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DatePipe } from '@angular/common';
import { NotifyService } from 'src/app/shared/services/notify.service';
import { selectProfessionLista } from 'src/app/store/profession/profession.selectors';
import { loadProfession, loadProfessionFilter } from 'src/app/store/profession/profession.actions';
import { selectFuncionarioState } from 'src/app/store/funcionario/funcionario.selectors';
import { of } from 'rxjs';
import { ProfessionService } from 'src/app/shared/services/profession.service';
import { UserGroupService } from 'src/app/shared/services/user-group.service';
import { PageAccessControlService } from 'src/app/shared/services/page-access-control.service';

@Component({
  selector: 'app-funcionario-form',
  templateUrl: './funcionario-form.component.html',
  styleUrls: ['./funcionario-form.component.scss']
})
export class FuncionarioFormComponent implements OnInit {
  readonly PROFESSION_CATEGORY = '3';
  habilitarTabela: boolean = false

  placeholderPcalendar: string = 'Data de Início'
  isScheduleValid: boolean = false
  selectedCity: any
  action = this.modalService.action
  userGroupId!: number
  stateList = this.postalCodeService.states

  citiesList: any
  userGroups!: []
  isLoadingCities: boolean = false
  funcionarioState$ = this.store.select(selectFuncionarioState)
  listaUnidades$ = this.store.select(selectUnidadeLista);
  unitState$ = this.store.select(selectUnitState)
  unidadeFiltrada: any[] = []
  unidadeLista$ = this.store.select(selectUnitActiveList);
  ProfessionList$ = this.store.select(selectProfessionLista);
  userId = localStorage.getItem('userId')
  clientId = localStorage.getItem('clientId')

  get isNewUser() {
    return this.config.data?.id == null;
  }
  /*forms */

  employeeForm = this.fb.group({
    id: null,
    access_level: [null as any, Validators.required],
    name: ['', [Validators.required]],
    contactNumber: ['', { validators: [Validators.required, Validators.minLength(10)] }],
    email: ['', [Validators.required, Validators.email]],
    taxId: [null as any, { validators: [Validators.required, CustomValidator.validateTaxId()] }],
    identificationNumber: [''],
    birthdate: ['', { validators: [Validators.required, CustomValidator.validateDate()] }],
    grossSalary: [null as any],
    units: [null as any, [Validators.required]],
    profession: [null as any, [Validators.required]],
    address: this.fb.group({
      postalCode: [null as any, { validators: [CustomValidator.validateCep()] }],
      country: ['Brasil'],
      state: [''],
      city: [null as any],
      cityName: [null],
      ibge: [null as any],
      district: [''],
      streetAddress: [''],
      number: [null as any],
      address2: ['']
    }),
    entryDate: ['', { validators: [Validators.required, CustomValidator.validateDate()] }],
    numberOfChildren: [null as any],
    dailyTicketCost: [null as any],

    password: ['', [CustomValidator.required(this.isNewUser)]],
    confirmPassword: ['', [CustomValidator.required(this.isNewUser), CustomValidator.equalsTo('password')]],
    fotografia_file: [null as any],          /* back esta providenciando */
    comprovanteEndereco_file: [null as any], /* back esta providenciando */
    identidade_file: [null as any],          /* back esta providenciando */

    /* liberacoes  */
    recepcao: this.fb.group({
      ativar_todos: false,
      agenda: false,
      receitas: false,
      despesas_caixa: false,
      caixa: false
    }),
    cadastro: this.fb.group({
      ativar_todos: false,
      unit: [false, Validators.requiredTrue],
      professional: [false, Validators.requiredTrue],
      employee: [false, Validators.requiredTrue],
      payment_method: [false, Validators.requiredTrue],
      data: [false, Validators.requiredTrue],
      exam: [false, Validators.requiredTrue],
      service: [false, Validators.requiredTrue],
      exam_delivery: [false, Validators.requiredTrue]
    }),
    other_services: this.fb.group({
      exam_delivery: [false, Validators.requiredTrue],
    }),
    relatorios: this.fb.group({
      ativar_todos: false,
      professional_transfers: [false, Validators.requiredTrue],
      finantial: [false, Validators.requiredTrue],
      invoices: [false, Validators.requiredTrue]
    }),
    financeiro: this.fb.group({
      ativar_todos: false,
      revenue: [false, Validators.requiredTrue],
      cash_expense: [false, Validators.requiredTrue],
      bank_expense: [false, Validators.requiredTrue],
      invoices: [false, Validators.requiredTrue],
      payment_schedule: [false, Validators.requiredTrue],
      cash: [false, Validators.requiredTrue],
      comission: [false, Validators.requiredTrue],
    }),
    alertas: this.fb.group({
      ativar_todos: false,
      avaliacoes: false,
      solicitacoes_clientes_pendente_envio: false,
      solicitacoes_clientes_pendente_resolucao: false,
      solicitacoes_funcionarios: false,
      exames_pendentes: false,
      consultas_nao_pagas: false,
      notas_fiscais_com_erro_ultimas_vinte_quatro_horas: false,
    }),
    pendencias: this.fb.group({
      ativar_todos: false,
      avaliacoes: false,
      solicitacoes_clientes: false,
      entrega_exames: false,
    }),



    /* fim de liberacoes */


    /* agenda de funcionarios */
    startDay: [''],

    sunday: this.fb.group({
      dayOfTheWeek: 0,
      startTime: null,
      endTime: null
    }),

    monday: this.fb.group({
      dayOfTheWeek: 1,
      startTime: null,
      endTime: null
    }),

    tuesday: this.fb.group({
      dayOfTheWeek: 2,
      startTime: null,
      endTime: null
    }),

    wednesday: this.fb.group({
      dayOfTheWeek: 3,
      startTime: null,
      endTime: null
    }),

    thursday: this.fb.group({
      dayOfTheWeek: 4,
      startTime: null,
      endTime: null
    }),

    friday: this.fb.group({
      dayOfTheWeek: 5,
      startTime: null,
      endTime: null
    }),

    saturday: this.fb.group({
      dayOfTheWeek: 6,
      startTime: null,
      endTime: null
    }),

    /* fim da agenda */


  })

  constructor(
    private fb: FormBuilder,
    private modalService: ModalService,
    private postalCodeService: PostalCodeService,
    private store: Store<IFuncionarioState>,
    public config: DynamicDialogConfig,
    private notify: NotifyService,
    private ref: DynamicDialogRef,
    private userGroupService: UserGroupService,
    private pageAccessControlService: PageAccessControlService
  ) {
  }

  get employeeValidation() {
    return this.employeeForm.controls.name.invalid ||
      this.employeeForm.controls.contactNumber.invalid ||
      this.employeeForm.controls.taxId.invalid ||
      this.employeeForm.controls.email.invalid ||
      this.employeeForm.controls.birthdate.invalid ||
      this.employeeForm.controls.units.invalid ||
      this.employeeForm.controls.profession.invalid ||
      this.employeeForm.controls.entryDate.invalid ||
      this.employeeForm.controls.password.invalid ||
      this.employeeForm.controls.confirmPassword.invalid
  }

  ngOnInit(): void {

    this.funcionarioState$.subscribe(res => {
      console.log('unit state: ', res)
      if (res.type == "success" && res.action != "get") {
        this.ref.close();
      }
    })

    this.unidadeLista$.subscribe(res => {
      if (res.length == 1) {
        let idList = res.map((item: any) => item['@id'])
        this.employeeForm.controls.units.patchValue(idList)
      }
      //console.log('unidades ativas: ', res)
    })

    this.store.dispatch(loadProfessionFilter({ professionCategory: this.PROFESSION_CATEGORY }));

    this.listaUnidades$.subscribe(res => {
      return this.unidadeFiltrada = res.filter((item: any) => item.isActive == true)
    })

    this.userGroupService.get().subscribe({
      next: (res: any) => { this.userGroups = res['hydra:member'].filter((list: any) => list.id != 1) },
      error: (err: any) => { console.log('erro ao carregar: ', err) }
    })

    if (this.config.data?.id) {

      const data = this.config.data

      if (data.address?.state) {
        this.onChangeState(data.address.state, '', data.address.city)
      }

      const arrayUserGroup = data.userGroup.split('/')
      const groupId = arrayUserGroup[arrayUserGroup.length-1]

      this.employeeForm.patchValue({
        id: data.id,
        access_level: Number(groupId),
        name: data.name,
        contactNumber: data.contactNumber,
        email: data.email,
        taxId: data.taxId,
        identificationNumber: data.identificationNumber,
        birthdate: this.formatDateForPatch(data.birthdate),
        grossSalary: data.grossSalary,
        units: data.units,
        profession: data.profession,
        address: ({
          postalCode: data.address?.postalCode,
          country: data.address?.country,
          state: data.address?.state,
          //city: '',
          ibge: data.address?.ibge,
          cityName: data.address?.city,
          district: data.address?.district,
          streetAddress: data.address?.streetAddress,
          number: data.address?.number,
          address2: data.address?.address2
        }),
        entryDate: this.formatDateForPatch(data.entryDate),
        numberOfChildren: data.numberOfChildren,
        dailyTicketCost: data.dailyTicketCost != "null" ? data.dailyTicketCost : null,

        password: data.password,
        confirmPassword: data.password,
        fotografia_file: data.fotografia_file,          /* back esta providenciando */
        comprovanteEndereco_file: data.comprovanteEndereco_file, /* back esta providenciando */
        identidade_file: data.identidade_file,          /* back esta providenciando */

        sunday: {
          dayOfTheWeek: 0,
          startTime: data.employeeSchedule?.sunday?.startTime,
          endTime: data.employeeSchedule?.sunday?.endTime
        },

        monday: {
          dayOfTheWeek: 1,
          startTime: data.employeeSchedule?.monday?.startTime,
          endTime: data.employeeSchedule?.monday?.endTime
        },

        tuesday: {
          dayOfTheWeek: 2,
          startTime: data.employeeSchedule?.tuesday?.startTime,
          endTime: data.employeeSchedule?.tuesday?.endTime
        },

        wednesday: {
          dayOfTheWeek: 3,
          startTime: data.employeeSchedule?.wednesday?.startTime,
          endTime: data.employeeSchedule?.wednesday?.endTime
        },

        thursday: {
          dayOfTheWeek: 4,
          startTime: data.employeeSchedule?.thursday?.startTime,
          endTime: data.employeeSchedule?.thursday?.endTime
        },

        friday: {
          dayOfTheWeek: 5,
          startTime: data.employeeSchedule?.friday?.startTime,
          endTime: data.employeeSchedule?.friday?.endTime
        },

        saturday: {
          dayOfTheWeek: 6,
          startTime: data.employeeSchedule?.saturday?.startTime,
          endTime: data.employeeSchedule?.saturday?.endTime
        },

        recepcao: ({
          ativar_todos: data.liberacoes?.recepcao?.ativar_todos,
          agenda: data.liberacoes?.recepcao?.agenda,
          receitas: data.liberacoes?.recepcao?.receitas,
          despesas_caixa: data.liberacoes?.recepcao?.despesas_caixa,
          caixa: data.liberacoes?.recepcao?.caixa
        }),

        cadastro: ({
          ativar_todos: data.liberacoes?.cadastro?.ativar_todos,

        }),

        relatorios: ({
          ativar_todos: data.liberacoes?.relatorios?.ativar_todos,
        }),

        financeiro: ({
          ativar_todos: data.liberacoes?.financeiro?.ativar_todos,

        }),

        alertas: ({
          ativar_todos: data.liberacoes?.alertas?.ativar_todos,
          avaliacoes: data.liberacoes?.alertas?.avaliacoes,
          solicitacoes_clientes_pendente_envio: data.liberacoes?.alertas?.solicitacoes_clientes_pendente_envio,
          solicitacoes_clientes_pendente_resolucao: data.liberacoes?.alertas?.solicitacoes_clientes_pendente_resolucao,
          solicitacoes_funcionarios: data.liberacoes?.alertas?.solicitacoes_funcionarios,
          exames_pendentes: data.liberacoes?.alertas?.exames_pendentes,
          consultas_nao_pagas: data.liberacoes?.alertas?.consultas_nao_pagas,
          notas_fiscais_com_erro_ultimas_vinte_quatro_horas: data.liberacoes?.alertas?.notas_fiscais_com_erro_ultimas_vinte_quatro_horas,
        }),

        pendencias: ({
          ativar_todos: data.liberacoes?.pendencias?.ativar_todos,
          avaliacoes: data.liberacoes?.pendencias?.avaliacoes,
          solicitacoes_clientes: data.liberacoes?.pendencias?.solicitacoes_clientes,
          entrega_exames: data.liberacoes?.pendencias?.entrega_exames,
        }),

      })
      this.setPermission()
    }

    //console.log('form : ', this.employeeForm.value)

    this.store.dispatch(loadUnidade());

    this.changePlaceholderPcalendar()
  }

  onSubmit() {

    const form = this.employeeForm.value

    this.citiesList?.forEach(
      (cidade: any) => {
        if (cidade.id == this.employeeForm.controls.address.value.city) {
          this.selectedCity = cidade.nome
        }
      }
    )

    const req: IFuncionario | any = {
      client: `/api/clients/${this.clientId}`,
      userGroup: this.userGroupId? `/api/user_groups/${this.userGroupId}` : null,
      isActive: true,
      name: form.name as string,
      contactNumber: form.contactNumber as string,
      email: form.email as string,
      taxId: form.taxId as string,
      identificationNumber: form.identificationNumber as string,
      birthdate: this.formatDate(form.birthdate),
      grossSalary: form.grossSalary as string,
      units: form.units as any,
      // profession: {
      //   name: form.profession.name as string,
      //   description: form.profession.description as string
      // },
      profession: form.profession,
      address: form.address?.postalCode ? {
        postalCode: form.address?.postalCode,
        country: form.address?.country as string,
        state: form.address?.state as string,
        city: this.selectedCity,
        ibge: form.address?.ibge as string,
        district: form.address?.district as string,
        streetAddress: form.address?.streetAddress as string,
        number: String(form.address?.number),
        address2: form.address?.address2 as string
      } : null,
      //entryDate: form.entryDate as string,
      entryDate: this.formatDate(form.entryDate),
      numberOfChildren: form.numberOfChildren,
      dailyTicketCost: String(form.dailyTicketCost),
      password: form.password,
      fotografia_file: form.fotografia_file,
      comprovanteEndereco_file: form.comprovanteEndereco_file,
      identidade_file: form.identidade_file
      // employeeSchedule: {
      //   date: form.startDay,
      //   sunday: {
      //     dayOfTheWeek: 0,
      //     startTime: form.sunday?.startTime,
      //     endTime: form.sunday?.endTime
      //   },
      //   monday: {
      //     dayOfTheWeek: 1,
      //     startTime: form.monday?.startTime,
      //     endTime: form.monday?.endTime
      //   },
      //   tuesday: {
      //     dayOfTheWeek: 2,
      //     startTime: form.tuesday?.startTime,
      //     endTime: form.tuesday?.endTime
      //   },

      //   wednesday: {
      //     dayOfTheWeek: 3,
      //     startTime: form.wednesday?.startTime,
      //     endTime: form.wednesday?.endTime
      //   },

      //   thursday: {
      //     dayOfTheWeek: 4,
      //     startTime: form.thursday?.startTime,
      //     endTime: form.thursday?.endTime
      //   },

      //   friday: {
      //     dayOfTheWeek: 5,
      //     startTime: form.friday?.startTime,
      //     endTime: form.friday?.endTime
      //   },

      //   saturday: {
      //     dayOfTheWeek: 6,
      //     startTime: form.saturday?.startTime,
      //     endTime: form.saturday?.endTime
      //   },
      // },
      // liberacoes: {
      //   recepcao: {
      //     ativar_todos: form.recepcao?.ativar_todos,
      //     agenda: form.recepcao?.agenda,
      //     receitas: form.recepcao?.receitas,
      //     despesas_caixa: form.recepcao?.despesas_caixa,
      //     caixa: form.recepcao?.caixa
      //   },
      //   cadastro: {
      //     ativar_todos: form.cadastro?.ativar_todos,
      //     profissionais: form.cadastro?.profissionais,
      //     unidades: form.cadastro?.unidades,
      //     contabilidade: form.cadastro?.contabilidade,
      //     formas_pagamento: form.cadastro?.formas_pagamento,
      //     condicionais: form.cadastro?.condicionais,
      //     dados: form.cadastro?.dados
      //   },
      //   relatorios: {
      //     ativar_todos: form.relatorios?.ativar_todos,
      //     financeiro: form.relatorios?.financeiro,
      //     atendimentos: form.relatorios?.atendimentos,
      //     repasses_profissionais: form.relatorios?.repasses_profissionais,
      //     nota_fiscal: form.relatorios?.nota_fiscal,
      //     funcionarios: form.relatorios?.funcionarios
      //   },
      //   financeiro: {
      //     ativar_todos: form.financeiro?.ativar_todos,
      //     notas_fiscais: form.financeiro?.notas_fiscais,
      //     calendario_pagamentos: form.financeiro?.calendario_pagamentos,
      //     despesas_bancarias: form.financeiro?.despesas_bancarias,
      //   },
      //   alertas: {
      //     ativar_todos: form.alertas?.ativar_todos,
      //     avaliacoes: form.alertas?.avaliacoes,
      //     solicitacoes_clientes_pendente_envio: form.alertas?.solicitacoes_clientes_pendente_envio,
      //     solicitacoes_clientes_pendente_resolucao: form.alertas?.solicitacoes_clientes_pendente_resolucao,
      //     solicitacoes_funcionarios: form.alertas?.solicitacoes_funcionarios,
      //     exames_pendentes: form.alertas?.exames_pendentes,
      //     consultas_nao_pagas: form.alertas?.consultas_nao_pagas,
      //     notas_fiscais_com_erro_ultimas_vinte_quatro_horas: form.alertas?.notas_fiscais_com_erro_ultimas_vinte_quatro_horas,
      //   },
      //   pendencias: {
      //     ativar_todos: form.pendencias?.ativar_todos,
      //     avaliacoes: form.pendencias?.avaliacoes,
      //     solicitacoes_clientes: form.pendencias?.solicitacoes_clientes,
      //     entrega_exames: form.pendencias?.entrega_exames,
      //   }

      // }

    }

    //console.log('req form: ', this.employeeForm.value)

    if (this.config.data?.id) {

      this.store.dispatch(funcionarioActions.editFuncionario({ funcionario: req, id: this.config.data.id }))

    } else {

      this.store.dispatch(funcionarioActions.saveFuncionario({ funcionario: req }))
    }

    //this.ref.close()

  }

  validateChar(event: KeyboardEvent) {
    const regex = /^[a-zA-ZáàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ\s]+$/;

    const key = event.key;

    if (!regex.test(key)) {
      event.preventDefault();
    }
  }

  onChangeSchedule() {

    const sunday = this.employeeForm.controls.sunday.value
    const monday = this.employeeForm.controls.monday.value
    const tuesday = this.employeeForm.controls.tuesday.value
    const wednesday = this.employeeForm.controls.wednesday.value
    const thursday = this.employeeForm.controls.thursday.value
    const friday = this.employeeForm.controls.friday.value
    const saturday = this.employeeForm.controls.saturday.value

    if (sunday.startTime || sunday.endTime) {
      if (this.isGreater(sunday.startTime, sunday.endTime)) {
        this.isScheduleValid = true
      } else {
        this.isScheduleValid = false
      }
    }

    if (monday.startTime || monday.endTime) {
      if (this.isGreater(monday.startTime, monday.endTime)) {
        this.isScheduleValid = true
      } else {
        this.isScheduleValid = false
      }
    }

    if (tuesday.startTime || tuesday.endTime) {
      if (this.isGreater(tuesday.startTime, tuesday.endTime)) {
        this.isScheduleValid = true
      } else {
        this.isScheduleValid = false
      }
    }

    if (wednesday.startTime || wednesday.endTime) {
      if (this.isGreater(wednesday.startTime, wednesday.endTime)) {
        this.isScheduleValid = true
      } else {
        this.isScheduleValid = false
      }
    }

    if (thursday.startTime || thursday.endTime) {
      if (this.isGreater(thursday.startTime, thursday.endTime)) {
        this.isScheduleValid = true
      } else {
        this.isScheduleValid = false
      }
    }

    if (friday.startTime || friday.endTime) {
      if (this.isGreater(friday.startTime, friday.endTime)) {
        this.isScheduleValid = true
      } else {
        this.isScheduleValid = false
      }
    }

    if (saturday.startTime || saturday.endTime) {
      if (this.isGreater(saturday.startTime, saturday.endTime)) {
        this.isScheduleValid = true
      } else {
        this.isScheduleValid = false
      }
    }

  }

  formatDate(date: any) {
    if (date == '' || date == null || date == undefined) {
      return null
    }

    let str = date;
    return str.substring(4) + '-' + str.substring(2, 4) + '-' + str.substring(0, 2);
  }

  formatDateForPatch(date: any) {
    let str = date;
    return str.substring(8, 10) + str.substring(5, 7) + str.substring(0, 4);
  }

  isGreater(param1: any, param2: any) {
    const [hour1, minutes1] = param1.split(':').map(Number)
    const [hour2, minutes2] = param2.split(':').map(Number)

    if (hour2 > hour1) {
      return true
    } else if (hour2 == hour1 && minutes2 > minutes1) {
      return true
    } else { return false }
  }

  onChangeUploadFile(item: string, event: any) {
    const files = event.srcElement.files
    const element = document.getElementById(item)
    const file = event.target.files[0] as File;
    //console.log(event)

    if (item == 'fotografia') {
      if (
        (event.target.files[0]?.type == "image/png") ||
        (event.target.files[0]?.type == "image/jpeg")
      ) {
        this.setValidStyle(element!, files[0].name)
        this.employeeForm.get('fotografia_file')?.setValue(file)
      } else {
        this.notify.emitError('Formato Inválido, Insira um arquivo do tipo \'PNG\', \'JPEG\' ou \'JPG\'')
      }
    } else if (item == 'identidade') {
      if (
        (event.target.files[0]?.type == "image/png") ||
        (event.target.files[0]?.type == "image/jpeg") ||
        (event.target.files[0].type == "application/pdf")
      ) {
        this.setValidStyle(element!, files[0].name)
        this.employeeForm.get('identidade_file')?.setValue(file)
      } else {
        this.notify.emitError('Formato Inválido, Insira um arquivo do tipo \'PNG\', \'JPEG\', \'JPG\' ou \'PDF\'')
      }
    } else if (item == 'comprovanteResidencia') {
      if (
        (event.target.files[0]?.type == "image/png") ||
        (event.target.files[0]?.type == "image/jpeg") ||
        (event.target.files[0].type == "application/pdf")
      ) {
        this.setValidStyle(element!, files[0].name)
        this.employeeForm.get('comprovanteEndereco_file')?.setValue(file)
      } else {
        this.notify.emitError('Formato Inválido, Insira um arquivo do tipo \'PNG\', \'JPEG\', \'JPG\' ou \'PDF\'')
      }
    }
    this.setFormData()

  }

  setFormData() {
    const form = this.employeeForm
    const formDataFoto = new FormData();
    const formDataIdentidade = new FormData();
    const formDataComprovante = new FormData();

    if (form.get('fotografia_file')?.value) {
      formDataFoto.append('fotografia', form.get('fotografia_file')?.value);
      form.get('fotografia_file')?.setValue(formDataFoto)
      //console.log('form data: ', formDataFoto)
    }

    if (form.get('identidade_file')?.value) {
      formDataIdentidade.append('identidade', form.get('identidade_file')?.value);
      form.get('identidade_file')?.setValue(formDataIdentidade)
      //console.log('form data: ', formDataIdentidade)
    }

    if (form.get('comprovanteEndereco_file')?.value) {
      formDataComprovante.append('comprovanteEndereco', form.get('comprovanteEndereco_file')?.value);
      form.get('comprovanteEndereco_file')?.setValue(formDataComprovante)
      //console.log('form data: ', formDataComprovante)
    }

    //console.log(this.employeeForm.value)
  }

  setValidStyle(element: HTMLElement, name: string) {
    element.innerHTML = name
    element.style.borderColor = '#086975'
    element.style.color = '#086975'
    element.style.fontSize = '1rem'
  }

  onChangeState(UF: any, cityID?: string, cityName?: string) {
    this.isLoadingCities = true

    if (!UF || UF == '') {

      this.employeeForm.patchValue({
        address: ({
          city: null as any
        })
      })

      this.isLoadingCities = false
      return this.citiesList = null
    }

    return this.postalCodeService.getCitiesByState(UF).subscribe({
      next: (res: any) => {
        this.citiesList = res

        if (cityID != null && cityID != '') {

          this.employeeForm.patchValue({
            address: {
              city: Number(cityID)
            }
          })
        } else {
          for (let item of res) {
            if (item.nome == cityName) {
              this.employeeForm.patchValue({
                address: {
                  city: item.id
                }
              })
            }
          }
        }


        this.isLoadingCities = false
      },
      error: (err: any) => {
        this.notify.emitError(err)
      }

    })
  }

  onChangeRecepcao(event: any) {
    const recepcao = this.employeeForm.controls.recepcao
    if (!event.checked) {
      recepcao.patchValue({
        ativar_todos: false
      })
    } else if (
      recepcao.value.agenda == true &&
      recepcao.value.caixa == true &&
      recepcao.value.despesas_caixa == true &&
      recepcao.value.receitas == true
    ) {
      recepcao.patchValue({
        ativar_todos: true
      })
    }
  }

  onChangeCadastro(event: any) {
    const cadastro = this.employeeForm.controls.cadastro
    if (!event.checked) {
      cadastro.patchValue({
        ativar_todos: false
      })
    } else if (
      this.employeeForm.controls.cadastro.valid
    ) {
      cadastro.patchValue({
        ativar_todos: true
      })
    }
  }

  onChangeRelatorios(event: any) {
    const relatorios = this.employeeForm.controls.relatorios
    if (!event.checked) {
      relatorios.patchValue({
        ativar_todos: false
      })
    } else if (
      this.employeeForm.controls.relatorios.valid
    ) {
      relatorios.patchValue({
        ativar_todos: true
      })
    }
  }

  onChangeFinanceiro(event: any) {
    const financeiro = this.employeeForm.controls.financeiro
    if (!event.checked) {
      financeiro.patchValue({
        ativar_todos: false
      })
    } else if (
      this.employeeForm.controls.financeiro.valid
    ) {
      financeiro.patchValue({
        ativar_todos: true
      })
    }
  }

  onChangeAlertas(event: any) {
    const alertas = this.employeeForm.controls.alertas
    if (!event.checked) {
      alertas.patchValue({
        ativar_todos: false
      })
    } else if (
      alertas.value.avaliacoes &&
      alertas.value.consultas_nao_pagas &&
      alertas.value.exames_pendentes &&
      alertas.value.notas_fiscais_com_erro_ultimas_vinte_quatro_horas &&
      alertas.value.solicitacoes_clientes_pendente_envio &&
      alertas.value.solicitacoes_clientes_pendente_resolucao &&
      alertas.value.solicitacoes_funcionarios
    ) {
      alertas.patchValue({
        ativar_todos: true
      })
    }
  }

  onChangePendencias(event: any) {
    const pendencias = this.employeeForm.controls.pendencias
    if (!event.checked) {
      pendencias.patchValue({
        ativar_todos: false
      })
    } else if (
      pendencias.value.avaliacoes &&
      pendencias.value.entrega_exames &&
      pendencias.value.solicitacoes_clientes
    ) {
      pendencias.patchValue({
        ativar_todos: true
      })
    }
  }

  fillAddress(cep: any) {
    cep = cep.replace(/\D/g, '');

    this.postalCodeService.getPostalCode(cep).subscribe({
      next: (res) => {

        this.onChangeState(res.uf, res.ibge)

        this.employeeForm.patchValue({
          address: ({
            //postalCode: res.cep,
            country: 'Brasil',
            ibge: res.ibge,
            //city: res.localidade,
            state: res.uf,
            district: res.bairro,
            streetAddress: res.logradouro
          })
        })

      },
      //error: (error) => console.log(error)
    })
  }

  changePlaceholderPcalendar() {
    this.modalService.action == 'cadastrar' ? this.placeholderPcalendar = 'Data de início' : this.placeholderPcalendar = 'Data de alteração'
  }

  ativarhabilitarTabela() {
    this.habilitarTabela = true
  }

  activelAllChildren(item: string) {
    const form = this.employeeForm.value

    switch (item) {
      case 'recepcao':
        if (form.recepcao?.ativar_todos) {
          this.employeeForm.controls.recepcao.patchValue({
            agenda: true,
            receitas: true,
            despesas_caixa: true,
            caixa: true
          })
        } else {
          this.employeeForm.controls.recepcao.reset()
        }
        break;
      case 'cadastro':
        if (form.cadastro?.ativar_todos) {
          Object.keys(this.employeeForm.controls.cadastro.controls).forEach(c => {
            this.employeeForm.controls.cadastro.get(c)?.setValue(true)
          })
        } else {
          this.employeeForm.controls.cadastro.reset()
        }
        break;
      case 'relatorios':
        if (form.relatorios?.ativar_todos) {
          Object.keys(this.employeeForm.controls.relatorios.controls).forEach(c => {
            this.employeeForm.controls.relatorios.get(c)?.setValue(true)
          })
        } else {
          this.employeeForm.controls.relatorios.reset()
        }
        break;
      case 'financeiro':
        if (form.financeiro?.ativar_todos) {
          Object.keys(this.employeeForm.controls.financeiro.controls).forEach(c => {
            this.employeeForm.controls.financeiro.get(c)?.setValue(true)
          })
        } else {
          this.employeeForm.controls.financeiro.reset()
        }
        break;
      case 'alertas':
        if (form.alertas?.ativar_todos) {
          this.employeeForm.controls.alertas.patchValue({
            avaliacoes: true,
            solicitacoes_clientes_pendente_envio: true,
            solicitacoes_clientes_pendente_resolucao: true,
            solicitacoes_funcionarios: true,
            exames_pendentes: true,
            consultas_nao_pagas: true,
            notas_fiscais_com_erro_ultimas_vinte_quatro_horas: true,
          })
        } else {
          this.employeeForm.controls.alertas.reset()
        }
        break;
      case 'pendencias':
        if (form.pendencias?.ativar_todos) {
          this.employeeForm.controls.pendencias.patchValue({
            avaliacoes: true,
            solicitacoes_clientes: true,
            entrega_exames: true,
          })
        } else {
          this.employeeForm.controls.pendencias.reset()
        }
        break;
      default:
        break;
    }

  }

  onActiveIndexChanged(index: number): void {
    if (this.modalService.action == 'cadastrar') {
      switch (index) {
        case 0:
          this.modalService.changeHeader('Cadastro do Funcionário');
          break;
        case 1:
          this.modalService.changeHeader('Liberações dos Funcionários');
          break;
        case 2:
          this.modalService.changeHeader('Escala');
          break;
      }
    } else if (this.modalService.action == 'editar') {
      switch (index) {
        case 0:
          this.modalService.changeHeader('Editar Funcionário');
          break;
        case 1:
          this.modalService.changeHeader('Editar Liberações dos Funcionários');
          break;
        case 2:
          this.modalService.changeHeader('Editar Escala');
          break;
      }
    }


  }

  setPermission() {
    const form = this.employeeForm.controls
    const accessID = this.employeeForm.value.access_level
    this.userGroupId = Number(accessID)

    form.financeiro.reset()
    form.relatorios.reset()
    form.cadastro.reset()
    form.other_services.reset()

    this.pageAccessControlService.getById(Number(accessID)).subscribe({
      next: (res: any) => {
        let permissions = res['hydra:member']

        permissions.forEach((p: any) => {
          //console.log(p)
          switch (p.page) {
            case 'Receitas':
              form.financeiro.controls.revenue.setValue(true);
              break;
            case 'Despesa Caixa':
            case 'Despesas Caixa':
            case 'Despesa  Caixa':
            case 'Despesas Caixas':
              form.financeiro.controls.cash_expense.setValue(true)
              break;
            case 'Caixa':
              form.financeiro.controls.cash.setValue(true)
              break;
            case 'Despesas Bancárias':
              form.financeiro.controls.bank_expense.setValue(true)
              break;
            case 'Nota Fiscal':
              form.financeiro.controls.invoices.setValue(true)
              break;
            case 'Comissão':
              form.financeiro.controls.comission.setValue(true)
              break;
            case 'Calendário de Pagamentos':
            case 'Calendário de Pagamento':
              form.financeiro.controls.payment_schedule.setValue(true)
              break;
            case 'Unidades':
              form.cadastro.controls.unit.setValue(true)
              break;
            case 'Profissionais':
              form.cadastro.controls.professional.setValue(true)
              break;
            case 'Funcionários':
              form.cadastro.controls.employee.setValue(true)
              break;
            case 'Formas de Pagamento':
              form.cadastro.controls.payment_method.setValue(true)
              break;
            case 'Dados Cadastro':
              form.cadastro.controls.data.setValue(true)
              break;
            case 'Exames':
              form.cadastro.controls.exam.setValue(true)
              break;
            case 'Serviços':
              form.cadastro.controls.service.setValue(true)
              break;
            case 'Entrega Exames':
              form.other_services.controls.exam_delivery.setValue(true)
              break;
          }

          if (p.isReport) {
            switch (p.page) {
              case 'Nota Fiscal':
                form.relatorios.controls.invoices.setValue(true)
                break;
              case 'Repasses Profissionais':
                form.relatorios.controls.professional_transfers.setValue(true)
                break;
              case 'Financeiro':
                form.relatorios.controls.finantial.setValue(true)
                break;
            }
          }

        })

        const commissionGroups = [1, 3, 5, 6, 7, 8, 9, 10, 14]
        if (commissionGroups.includes(Number(accessID))) {
          form.financeiro.controls.comission.setValue(true)
        }

      }
    })

  }

  /* dados mocados */

  profissaoLista: any[] = [
    {
      "@id": "/api/professions/1",
      "@type": "Profession",
      "id": 1,
      "name": "Médico",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "CRM",
      "exceptionList": [],
      "employees": [
        "/api/employees/89",
        "/api/employees/94",
        "/api/employees/96"
      ]
    },
    {
      "@id": "/api/professions/2",
      "@type": "Profession",
      "id": 2,
      "name": "Dentista",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "CRO",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/3",
      "@type": "Profession",
      "id": 3,
      "name": "Nutricionista",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "CRN",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/4",
      "@type": "Profession",
      "id": 4,
      "name": "Enfermeiro",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "COREN",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/5",
      "@type": "Profession",
      "id": 5,
      "name": "Fisioterapeuta",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "CREFITO",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/6",
      "@type": "Profession",
      "id": 6,
      "name": "Terapeuta Ocupacional",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "CREFITO",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/7",
      "@type": "Profession",
      "id": 7,
      "name": "Fonoaudiólogo",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "CREFONO",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/8",
      "@type": "Profession",
      "id": 8,
      "name": "Veterinário",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "CRMV",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/9",
      "@type": "Profession",
      "id": 9,
      "name": "Psicólogo",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "CRP",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/10",
      "@type": "Profession",
      "id": 10,
      "name": "Outro profissional da saúde",
      "professionCategory": "/api/profession_categories/1",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/11",
      "@type": "Profession",
      "id": 11,
      "name": "Cabeleireiro",
      "professionCategory": "/api/profession_categories/2",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/12",
      "@type": "Profession",
      "id": 12,
      "name": "Esteticista",
      "professionCategory": "/api/profession_categories/2",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/13",
      "@type": "Profession",
      "id": 13,
      "name": "Manicure e Pedicure",
      "professionCategory": "/api/profession_categories/2",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/14",
      "@type": "Profession",
      "id": 14,
      "name": "Maquiador",
      "professionCategory": "/api/profession_categories/2",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/15",
      "@type": "Profession",
      "id": 15,
      "name": "Massoterapeuta",
      "professionCategory": "/api/profession_categories/2",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/16",
      "@type": "Profession",
      "id": 16,
      "name": "Terapeuta Holístico",
      "professionCategory": "/api/profession_categories/2",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/17",
      "@type": "Profession",
      "id": 17,
      "name": "Outro profissional de beleza e bem estar",
      "professionCategory": "/api/profession_categories/2",
      "exceptionList": [],
      "employees": []
    }
    // {
    //   "@id": "/api/professions/18",
    //   "@type": "Profession",
    //   "id": 18,
    //   "name": "Secretária",
    //   "professionCategory": "/api/profession_categories/2",
    //   "exceptionList": [],
    //   "employees": []
    // },
    // {
    //   "@id": "/api/professions/19",
    //   "@type": "Profession",
    //   "id": 19,
    //   "name": "Gerente",
    //   "professionCategory": "/api/profession_categories/2",
    //   "exceptionList": [],
    //   "employees": []
    // },
    // {
    //   "@id": "/api/professions/20",
    //   "@type": "Profession",
    //   "id": 20,
    //   "name": "Assistente Administrativo",
    //   "professionCategory": "/api/profession_categories/2",
    //   "exceptionList": [],
    //   "employees": []
    // },
    // {
    //   "@id": "/api/professions/21",
    //   "@type": "Profession",
    //   "id": 21,
    //   "name": "Técnico de Enfermagem",
    //   "professionCategory": "/api/profession_categories/2",
    //   "exceptionList": [],
    //   "employees": []
    // }
  ]

  NumFilhosLista: any[] = [

    { label: 'Nenhum', value: 0 },
    { label: '1 Filho', value: 1 },
    { label: '2 Filhos', value: 2 },
    { label: '3 Filhos', value: 3 },
    { label: '4 Filhos', value: 4 },
    { label: '5 Filho', value: 5 },
    { label: '6 Filhos', value: 6 },
    { label: '7 Filhos', value: 7 },
    { label: '8 Filhos', value: 8 },
    { label: '9 Filhos', value: 9 },
    { label: '10 Filhos', value: 10 },
  ]
}
